export default {
  support: [
    {
      name: 'ENTERPRISE',
      path: '/en/enterprise',
    },
    {
      name: 'Support',
      submenus: [
        { text: 'Technology', path: '/en/enterprise/technology/uwb' },
        { text: 'Blog', path: '/en/blog' },
        { text: 'Contact', path: '/en/request' },
        { text: 'Company', path: '/en/company' },
      ],
    },
  ],

  lang: [
    {
      name: 'Language',
      submenus: [{ text: '한국어' }, { text: 'Tiếng Việt' }, { text: 'English' }, { text: '日本語' }],
    },
  ],
};
